export default __webpack_public_path__ + "static/media/caret-right.52d4af31.svg";